import apiClient from 'core/api/client';
import type { ActiveOffer, OrderResponse, OrderStatus } from 'types/api.generated';

export interface ListOrdersResponse {
  orders: OrderResponse[];
  total: number;
  page: number;
  perPage: number;
  totalPages: number;
}

export const getActiveOffer = async (): Promise<ActiveOffer> => {
  const { data } = await apiClient.get<ActiveOffer>('/api/v1/orders/active-offer');
  return data;
};

export const listMyAssignedOrders = async (params?: {
  page?: number;
  perPage?: number;
  status?: OrderStatus;
}): Promise<ListOrdersResponse> => {
  const { data } = await apiClient.get<ListOrdersResponse>('/api/v1/orders/mine/assigned', {
    params,
  });
  return data;
};

export const acceptOrder = async (id: string): Promise<OrderResponse> => {
  const { data } = await apiClient.post<OrderResponse>(`/api/v1/orders/${id}/accept`);
  return data;
};

export const declineOrder = async (id: string): Promise<void> => {
  await apiClient.post(`/api/v1/orders/${id}/decline`);
};

export const releaseOrder = async (id: string): Promise<void> => {
  await apiClient.post(`/api/v1/orders/${id}/release`);
};

export const updateOrderStatus = async (
  id: string,
  status: 'picked_up' | 'in_transit' | 'delivered',
): Promise<void> => {
  await apiClient.patch(`/api/v1/orders/${id}/status`, { status });
};
